<p class="bold m-3">Create event</p>

<form class="m-3" [formGroup]="innerForm" (ngSubmit)="submit()">
  <div class="row">
    <div class="col-md-12">
      <app-input
        [fc]="innerForm.controls.event_id"
        [label]="'Id (filled = edit / empty = new)'">
      </app-input>
    </div>
    <div class="col-md-12">
      <app-input
        [fc]="innerForm.controls.event_name"
        [label]="'Name'">
      </app-input>
    </div>
    <div class="col-md-8">
      <app-location-autocomplete
        [fc]="innerForm.controls.event_location"
        [mapRef]="map"
        [label]="'location' | t"></app-location-autocomplete>

      <app-google-map #map class="create-event__location-map"></app-google-map>
    </div>
    <div class="col-md-12">
      <app-input
        [fc]="innerForm.controls.event_start"
        [label]="'Start Date Time'"
        type="datetime-local"
      ></app-input>
    </div>
    <div class="col-md-12">
      <app-input
        [fc]="innerForm.controls.event_finish"
        [min]="minEventFinishDate"
        [label]="'Finish Date Time'"
        (inputBlur)="onEventFinishDateBlur($event)"
        type="datetime-local"
      ></app-input>
    </div>
    <div class="col-md-12">
      <app-text-editor
        [fc]="innerForm.controls.event_description"
        [label]="'Description'"
      ></app-text-editor>
    </div>
    <div class="col-md-12">
      <app-multiselect
        [fc]="innerForm.controls.categories"
        [options]="categoryOptions"
        [emptyOption]="false"
        [label]="'Categories'">
      </app-multiselect>
    </div>
    <div class="col-md-12">
      <app-select
        class="mb-3"
        [fc]="innerForm.controls.event_organization_id"
        [note]="'Organisation can\'t be changed later'"
        [options]="organizationOptions"
        [emptyOption]="false"
        [label]="'Organization'">
      </app-select>
    </div>
    <div class="col-md-12 mb-3">
      <app-checkbox
        [fc]="innerForm.controls.event_registration_open"
        [label]="'Registration is open'"
      ></app-checkbox>
    </div>
    <div class="col-md-12 mb-3">
      <app-checkbox
        [fc]="innerForm.controls.event_top"
        [label]="'Pin event on top'"
      ></app-checkbox>
    </div>
  </div>

  <app-button [submit]="true">
    {{innerForm.get('event_id')?.value ? 'Update' : 'Create'}}
  </app-button>
</form>
